var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"usersChart",attrs:{"id":"users-chart","width":"400","height":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }